// Centered delete confirmation — matches User Management (usermanagement.js DeleteUserModal).
import React from "react";
import PropTypes from "prop-types";
import { Modal, Box, Typography, Stack, Button } from "@mui/material";

import colors from "../../utils/colors";

const cancelButtonSx = {
  "&&": {
    height: 36,
    borderRadius: "8px",
    border: "1px solid",
    borderColor: "grey.300",
    color: "text.primary",
    backgroundColor: "common.white",
    fontSize: 14,
    fontWeight: 500,
    textTransform: "none",
    opacity: 1,
  },
  "&&:hover": {
    borderColor: "grey.500",
    color: "text.primary",
    backgroundColor: "common.white",
  },
  "&&:active": {
    borderColor: "grey.500",
    color: "text.primary",
    backgroundColor: "common.white",
  },
};

const deleteButtonSx = {
  "&&": {
    height: 36,
    borderRadius: "8px",
    border: "1px solid",
    borderColor: "error.main",
    backgroundColor: "error.main",
    color: "error.contrastText",
    fontSize: 14,
    fontWeight: 600,
    textTransform: "none",
    opacity: 1,
  },
  "&&:hover": {
    backgroundColor: "error.dark",
    borderColor: "error.dark",
    color: "error.contrastText",
  },
  "&&:active": {
    backgroundColor: "error.dark",
    borderColor: "error.dark",
    color: "error.contrastText",
  },
};

export default function DeleteConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel = "Delete",
  loading = false,
  width = 400,
}) {
  return (
    <Modal open={open} onClose={loading ? undefined : onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width,
          maxWidth: "94vw",
          backgroundColor: "#fff",
          borderRadius: "8px",
          p: 4,
          boxShadow: 24,
        }}
      >
        <Typography sx={{ fontSize: 18, fontWeight: "medium", color: colors.neutral[1000], mb: 2 }}>
          {title}
        </Typography>
        <Typography component="div" sx={{ fontSize: 14, color: colors.neutral[700], mb: 4 }}>
          {children}
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={onClose} disabled={loading} sx={cancelButtonSx}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm} disabled={loading} sx={deleteButtonSx}>
            {loading ? "Deleting…" : confirmLabel}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

DeleteConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string,
  loading: PropTypes.bool,
  width: PropTypes.number,
};
